export default __webpack_public_path__ + "static/media/apple-app-store-qr.1dcd4b1f.svg";